import React from 'react';
import { t } from '../../../../../../locales/translate';
import { useMutation } from '@apollo/client';
import { useModal } from '../../../../../../components/Modal/PresentedModal';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { Button } from '../../../../../../components/Button/Button';
import { graphql } from '../../../../../../generated';
import { Stack } from '../../../../../../components/Stack/Stack';
import { FormCheckbox } from '../../../../../../components/Form/Checkbox/FormCheckbox';

interface Props {
  eventId: string;
}

const RERENDER_TICKETS = graphql(`
  mutation RerenderTickets($eventId: ID!, $type: EventTicketType!) {
    rerenderTickets(input: { eventId: $eventId, type: $type }) {
      event {
        id
      }
    }
  }
`);

export function RerenderTickets({ eventId }: Props): JSX.Element {
  const { open, Modal, close } = useModal();
  const [rerender] = useMutation(RERENDER_TICKETS);
  const { fields, onSubmit, valid, submissionStatus } = useForm<{ online?: boolean; hard?: boolean }>({
    model: { online: false, hard: false },
    validations: {
      online: ({ model }) => (model.online || model.hard ? [] : ['At least one option must be selected']),
    },
    onSubmit: async ({ model }) => {
      const type = model.hard && model.online ? 'ALL' : model.online ? 'ONLINE' : 'HARD';
      await rerender({ variables: { eventId, type } });
      close();
    },
  });
  return (
    <Modal
      open={open}
      title={t.model.ticket.rerender.title}
      footer={
        <>
          <Button title={t.actions.cancel('')} onClick={close} />
          <Button
            type="primary"
            title={t.actions.save('')}
            onClick={onSubmit}
            disabled={!valid}
            loading={submissionStatus === 'submitting'}
          />
        </>
      }
    >
      <Stack>
        <FormCheckbox {...fields.online} label={t.model.ticket.rerender.online} />
        <FormCheckbox {...fields.hard} label={t.model.ticket.rerender.hard} />
        <div>{t.model.ticket.rerender.description}</div>
      </Stack>
    </Modal>
  );
}
